import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-details',
  templateUrl: 'details.html',
})
export class DetailsPage {
  modelData: any;
  activeTab: any = 1;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    let data = navParams.data.pageData.allData;
    let model = navParams.data.model;
    for (let item of data) {

      if (item.model == model) {
        this.modelData = item;
      }
    }
    // console.log(this.modelData);
  }

  tab(num) {
    this.activeTab = num;
  }

}



// WEBPACK FOOTER //
// ./src/pages/details/details.ts